import APITemplate from '@/api/APITemplate'

export default APITemplate('/api/device-command-task')
